import axios from "axios";
import "../../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGlobalVar, setGlobalVar } from "../../config/Config";
import Header from "../../../components/Header";
import { Button } from "react-bootstrap";

const POSCustomer = () => {
  const navigate = useNavigate();
  const globalVar = getGlobalVar();
  const baseurl = globalVar.url;
  const USER = JSON.parse(localStorage.getItem("auth"));
  const org = "?org=" + USER.org;
  const customersAPI = baseurl + "/accountingapi/GetVendors/" + org;
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);

  const fetchCustomers = async () => {
    try {
      const customerRes = await axios.get(customersAPI, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      });
      setCustomerData(customerRes.data);
    } catch (error) {
      console.log("Error fetching customers:", error);
    }
  };
  useEffect(() => {
    fetchCustomers();
  }, []);

  return (
    <>
      <div className="d-flex" style={{ height: "100vh" }}>
        {/* Sidebar and Header */}
        <Header />

        {/* Main Content */}
        <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px" }}>
          <div className="row ">
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <h1 className="text-2xl font-bold">Customers</h1>
                </div>
                <div className="col-6 d-flex justify-content-end">
                  <Button
                    className="xb"
                    onClick={() =>
                      window.open(
                        "https://accounting.defconinnovations.com/customers",
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Add Customer
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="row p-4">
            <div className="col-12 r-shadow">
              <div className="row mt-4">
                <div
                  className="col-12 "
                  style={{ height: "calc(100vh - 100px)", overflow: "scroll" }}
                >
                  <table className="table-auto w-full text-left">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="px-4 py-2">ID</th>
                        <th className="px-4 py-2">Name</th>
                        <th className="px-4 py-2">Address</th>
                        <th className="px-4 py-2">Phone</th>
                        <th className="px-4 py-2">Email</th>
                        <th className="px-4 py-2">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerData.length > 0 ? (
                        customerData.map((customer) => (
                          <tr
                            key={customer.id}
                            className="border-t customer-data-list"
                          >
                            {/* ID */}
                            <td className="px-4 py-2">{customer.id}</td>

                            {/* Name */}
                            <td className="px-4 py-2">{customer.Name}</td>

                            {/* Address (combined Street1 + Street2 + City + Zip + Country) */}
                            <td className="px-4 py-2">
                              {[
                                customer.Street1,
                                customer.Street2,
                                customer.City,
                                customer.Zip,
                                customer.Country,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            </td>

                            {/* Phone */}
                            <td className="px-4 py-2">{customer.Phone}</td>

                            {/* Email */}
                            <td className="px-4 py-2">{customer.Email}</td>

                            {/* Actions */}
                            <td className="px-4 py-2">
                              {/* Add your action buttons here */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-4">
                            No customers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default POSCustomer;
